import React from "react";

const FiltresTravail = ({ annonces, filters, onChange }) => {
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    const newFilters = { ...filters };

    if (type === "checkbox") {
      newFilters[name] = checked
        ? [...(filters[name] || []), value]
        : filters[name].filter((v) => v !== value);
    } else {
      newFilters[name] = value;
    }

    onChange(newFilters);
  };

  const uniqueSecteurs = [...new Set(annonces.map((a) => a.secteur).filter(Boolean))];
  const uniqueContrats = [...new Set(annonces.map((a) => a.contrat).filter(Boolean))];
  const uniqueVilles = [...new Set(annonces.map((a) => a.ville).filter(Boolean))];

  return (
    <div>
      <h3>Secteur d'activité</h3>
      {uniqueSecteurs.map((secteur) => (
        <label key={secteur}>
          <input type="checkbox" name="secteur" value={secteur} onChange={handleChange} />
          {secteur}
        </label>
      ))}

      <h3>Type de contrat</h3>
      {uniqueContrats.map((contrat) => (
        <label key={contrat}>
          <input type="checkbox" name="contrat" value={contrat} onChange={handleChange} />
          {contrat}
        </label>
      ))}

      <h3>Ville</h3>
      {uniqueVilles.map((ville) => (
        <label key={ville}>
          <input type="checkbox" name="ville" value={ville} onChange={handleChange} />
          {ville}
        </label>
      ))}

      <h3>Salaire</h3>
      <input
        type="number"
        name="salaireMin"
        placeholder="Min"
        value={filters.salaireMin}
        onChange={handleChange}
      />
      <input
        type="number"
        name="salaireMax"
        placeholder="Max"
        value={filters.salaireMax}
        onChange={handleChange}
      />
    </div>
  );
};

export default FiltresTravail;
